import { InventoryCountListPage } from "@/features/inventory-count/pages/InventoryCountListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inventory-count/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_count.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryCountListPage,
});
